import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

const queryClient = new QueryClient()

// Sentry.init({
//   dsn: "https://796cf99fcf494191b85921af0e0083ed@o1138360.ingest.sentry.io/4504638129569792",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

const root = ReactDOM.createRoot(
  document.getElementById('creditsfast_steper_root') as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      {/* <Sentry.ErrorBoundary fallback={<p>Error</p>} > */}
        <App />
      {/* </Sentry.ErrorBoundary> */}
    </React.StrictMode>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
